import { __decorate } from "tslib";
import { Component } from 'decorators';
import view from './optimizedPromptResult.view.html';
let OptimizedPromptResultComponent = class OptimizedPromptResultComponent {
    handleOpenModal() {
        this.onOpenModal?.();
    }
    handleCancel() {
        this.onCancel?.();
    }
    handleApply() {
        this.onApply?.();
    }
};
OptimizedPromptResultComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            optimizedPrompts: '<',
            onOpenModal: '&?',
            onCancel: '&?',
            onApply: '&?',
        },
    })
], OptimizedPromptResultComponent);
export { OptimizedPromptResultComponent };
